import { render, staticRenderFns } from "./YzSSO.vue?vue&type=template&id=0d94aa37&scoped=true&"
import script from "./YzSSO.vue?vue&type=script&lang=js&"
export * from "./YzSSO.vue?vue&type=script&lang=js&"
import style0 from "./YzSSO.vue?vue&type=style&index=0&id=0d94aa37&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d94aa37",
  null
  
)

/* custom blocks */
import block0 from "./YzSSO.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports